"use client"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  // Group toasts by position
  const groupedToasts = toasts.reduce((acc, toast) => {
    const position = toast.position || 'default';
    if (!acc[position]) {
      acc[position] = [];
    }
    acc[position].push(toast);
    return acc;
  }, {} as Record<string, typeof toasts>);

  return (
    <ToastProvider>
      {/* Default position viewport */}
      {groupedToasts['default'] && (
        <ToastViewport position="default">
          {groupedToasts['default'].map((toast) => (
            <Toast key={toast.id} {...toast} />
          ))}
        </ToastViewport>
      )}

      {/* Centered position viewport */}
      {groupedToasts['centered'] && (
        <ToastViewport position="centered">
          {groupedToasts['centered'].map((toast) => (
            <Toast key={toast.id} {...toast} />
          ))}
        </ToastViewport>
      )}

      {/* Top-right position viewport */}
      {groupedToasts['top-right'] && (
        <ToastViewport position="top-right">
          {groupedToasts['top-right'].map((toast) => (
            <Toast key={toast.id} {...toast} />
          ))}
        </ToastViewport>
      )}
    </ToastProvider>
  )
}
